<template>
  <div class="userinfo-main">
    <div class="info-box">
      <div class="info-item head-item">
        <div>微信头像</div>
        <div class="info-img">
          <img :src="infoData.HeadPortraitUrl" alt="" />
        </div>
      </div>
      <div class="info-item">
        <div>微信昵称</div>
        <div class="info-txt">{{ infoData.Nick || '----' }}</div>
      </div>
      <div class="info-item">
        <div>搜货会员名</div>
        <div class="info-txt">{{ infoData.LoginName || '无' }}</div>
      </div>
      <div class="info-item" @click="editPlatformNumber">
        <div>淘宝号</div>
        <div class="info-txt">{{ infoData.PlatformNumber || '无' }}<i class="iconfont icon-xiangzuo1"></i></div>
      </div>
      <div class="info-item border" @click="editPhone">
        <div>手机号</div>
        <div class="info-txt">{{ infoData.LoginName || '无' }}<i class="iconfont icon-xiangzuo1"></i></div>
      </div>
      <div class="info-item" @click="accountCancellation">
        <div>注销账号</div>
        <div class="info-txt"><i class="iconfont icon-xiangzuo1"></i></div>
      </div>
      <div class="info-item" @click="logOut">
        <div>退出登录</div>
        <div class="info-txt"><i class="iconfont icon-xiangzuo1"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import userInfo from './mixins/index'
import { MessageBox } from 'mint-ui'
import { mapActions } from 'vuex'
import { GetLogoutApplyForStatus } from '@/api/logoutApplyFor'
import { LOGOUT_APPLY_FOR_STATUS } from '@/constants/index'

export default {
  name: 'appUserInfo',
  mixins: [userInfo],
  methods: {
    ...mapActions(['loginOut']),
    // app退出登录
    logOut() {
      MessageBox({
        title: '提示',
        message: '确认退出登录吗？',
        showCancelButton: true,
        cancelButtonText: '我再想想',
        confirmButtonText: '确认',
        confirmButtonClass: 't_f23030'
      }).then((action) => {
        if (action === 'confirm') {
          this.loginOut().then(() => {
            this.$uni.postMessage({
              data: {
                logOut: true
              }
            })
          })
        }
      })
    },
    // 注销账号
    async accountCancellation() {
      // [accountCancellationNotice,inReview,applyForAccountCancellationStep1,applyForAccountCancellationStep2]
      // this.$router.push('applyForAccountCancellationStep1')
      try {
        const { Data } = await GetLogoutApplyForStatus()
        let tempRouterName = 'inReview'
        // 若审核状态为【待审核】，则展现为【注销待审核提示页面】
        // 若审核状态为空或【已取消】，则展现为【申请账号注销页面】
        if ([LOGOUT_APPLY_FOR_STATUS['已取消'], null].includes(Data)) {
          tempRouterName = 'applyForAccountCancellationStep1'
        }
        this.$router.push(tempRouterName)
      } catch (error) {
        this.$toast(error.ErrMsg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/index.scss';
</style>
